import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-primary via-primary-dark to-primary-dark text-white relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="animate-fade-in">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/432c5e6ce7481208eebd95eb1961bc97.png" 
                alt="GDH İstanbul 2025 Kongresi" 
                className="h-12 w-auto object-contain transition-transform duration-300 hover:scale-105"
              />
            </div>
            <p className="text-sm text-white/80 leading-relaxed mb-6">
              İstanbul'da düzenlenen ulusal ve uluslararası dental kongremiz, diş hekimliğinde bilimsel mükemmellik ve klinik deneyimin buluşma noktasıdır.
            </p>
            <div className="flex space-x-3">
              {['facebook', 'twitter', 'instagram', 'linkedin', 'youtube'].map((social) => (
                <a
                  key={social}
                  href={`https://${social}.com`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-accent hover:scale-110 transition-all duration-300 cursor-pointer"
                >
                  <i className={`ri-${social}-fill text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="animate-fade-in" style={{ animationDelay: '0.1s' }}>
            <h3 className="text-lg font-bold mb-6 text-accent">HIZLI ERİŞİM</h3>
            <ul className="space-y-3">
              {[
                { name: 'Ana Sayfa', path: '/' },
                { name: 'Program', path: '/program' },
                { name: 'Konuşmacılar', path: '/konusmacılar' },
                { name: 'Kurslar', path: '/kurslar' },
                { name: 'Önemli Tarihler', path: '/onemli-tarihler' },
                { name: 'Genel Bilgiler', path: '/genel-bilgiler' },
                { name: 'Kayıt', path: '/kayit' },
                { name: 'İletişim', path: '/iletisim' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-accent hover:translate-x-1 transition-all duration-300 cursor-pointer inline-block"
                  >
                    <i className="ri-arrow-right-s-line text-accent mr-1"></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="animate-fade-in" style={{ animationDelay: '0.2s' }}>
            <h3 className="text-lg font-bold mb-6 text-accent">İLETİŞİM</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 group">
                <div className="w-10 h-10 flex items-center justify-center bg-accent/20 rounded-lg group-hover:bg-accent transition-all duration-300">
                  <i className="ri-phone-line text-accent group-hover:text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-medium">Telefon</div>
                  <div className="text-sm text-white/80">+90 535 067 06 75</div>
                </div>
              </li>
              <li className="flex items-start space-x-3 group">
                <div className="w-10 h-10 flex items-center justify-center bg-accent/20 rounded-lg group-hover:bg-accent transition-all duration-300">
                  <i className="ri-mail-line text-accent group-hover:text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-medium">E-posta</div>
                  <div className="text-sm text-white/80">serkan@identaevent.com</div>
                </div>
              </li>
              <li className="flex items-start space-x-3 group">
                <div className="w-10 h-10 flex items-center justify-center bg-accent/20 rounded-lg group-hover:bg-accent transition-all duration-300">
                  <i className="ri-map-pin-line text-accent group-hover:text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-medium">Adres</div>
                  <div className="text-sm text-white/80">
                    İstanbul Atlas Üniversitesi
                  </div>
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <div className="bg-primary-dark/50 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-sm text-white/70">
              © 2025 Genç Diş Hekimliği Derneği İstanbul Kongresi. Tüm hakları saklıdır.
            </div>
            <div className="flex items-center space-x-6">
              <a href="/gizlilik" className="text-sm text-white/70 hover:text-accent transition-colors duration-300 cursor-pointer">
                Gizlilik Politikası
              </a>
              <a href="/kullanim-kosullari" className="text-sm text-white/70 hover:text-accent transition-colors duration-300 cursor-pointer">
                Kullanım Koşulları
              </a>
              <a href="/cerez-politikasi" className="text-sm text-white/70 hover:text-accent transition-colors duration-300 cursor-pointer">
                Çerez Politikası
              </a>
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="text-sm text-white/70 hover:text-accent transition-colors duration-300 cursor-pointer">
                CDCO
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;